<template>
  <div>
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <div style="text-align: center;font-size: 20px;">
      <button
        style="width:500px;height:100px;background-color:orange;margin:auto"
        @click="print()"
      >
        طباعة فاتورة مبيعات بكود
        <br />
        {{ fatwora.code }}
      </button>
    </div>
    <div id="printMe" style="display:none">
      <div style="direction:rtl;float:right">
        <p
          style="text-align:center;font-size:22px;font-weight:bold;margin-bottom:15px;text-decoration:underline;"
        >
          طباعة فاتورة مبيعات بكود
          {{ fatwora.code }}
        </p>
        <div class="row">
          <div class="col-sm-4" style="border-left:1px dotted">
            <div style="float:right;">
              <img
                style="width:100%;height:100px;"
                src="../../../public/images/pharma_logo.jpg"
                alt="Pharma"
              />
            </div>
          </div>
          <div class="col-sm-4">
            <div style="float:right;font-size:17px;text-align:right">
              <p>
                <span style="font-weight:bold;"> الكود : </span>
                <span> {{ fatwora.code }} </span>
              </p>

              <p>
                <span style="font-weight:bold;"> العميل : </span>
                <span> {{ fatwora.client ? fatwora.client.name : "" }} </span>
              </p>

              <p>
                <span style="font-weight:bold;"> المخزن : </span>
                <span> {{ fatwora.store ? fatwora.store.name : "" }} </span>
              </p>

              <p>
                <span style="font-weight:bold;"> مندوب التوزيع : </span>
                <span>
                  {{ fatwora.mandob_tawzi3 ? fatwora.mandob_tawzi3.name : "" }}
                </span>
              </p>

              <p>
                <span style="font-weight:bold;"> مندوب المبيعات : </span>
                <span>
                  {{
                    fatwora.client && fatwora.client.mandob_sales
                      ? fatwora.client.mandob_sales.name
                      : ""
                  }}
                </span>
              </p>
            </div>
          </div>
          <div class="col-sm-4">
            <div style="float:right;font-size:17px;text-align:right">
              <p>
                <span style="font-weight:bold;"> تاريخ التسليم : </span>
                <span> {{ fatwora.taslim_date }} </span>
              </p>

              <p>
                <span style="font-weight:bold;"> تاريخ الفاتورة : </span>
                <span> {{ fatwora.created_at }} </span>
              </p>

              <p>
                <span style="font-weight:bold;"> المديونية السابقة: </span>
                <span> {{ fatwora.madionia_sabqa }} </span>
              </p>

              <p>
                <span style="font-weight:bold;">المديونية الحالية : </span>
                <span> {{ fatwora.madionia_now }} </span>
              </p>
            </div>
          </div>
        </div>
        <br />
        <hr />
        <hr />
        <br />
        <br />
        <table class="table table-sm table-bordered" style="text-align:center">
          <thead>
            <tr>
              <th scope="col">اسم الصنف</th>
              <th scope="col">العدد</th>
              <th scope="col">البونص</th>
              <th scope="col">العدد النهائي</th>
              <th scope="col">سعر الوحدة</th>
              <th scope="col">سعر الوحدات</th>
              <th scope="col">خصم الوحدة</th>
              <th scope="col">السعر النهائي</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="f in fatwora.fatwora_items" :key="f.id">
              <th scope="row">{{ f.item_name }}</th>

              <td>{{ f.item_num }}</td>
              <td>{{ f.item_bonus }}</td>
              <td>{{ f.item_num_after }}</td>
              <td>{{ f.price }}</td>
              <td>{{ f.total_price }}</td>
              <td>{{ f.item_discount }}</td>
              <td>{{ f.final_price }}</td>
            </tr>
          </tbody>
        </table>
        <br />
        <hr />
        <br />
        <table
          class="table table-sm table-bordered"
          style="text-align:center; "
        >
          <thead>
            <tr style="border:2px double black;">
              <th scope="col">المجموع قبل الخصم</th>
              <th scope="col">الخصم</th>
              <th scope="col">المجموع بعد الخصم</th>
            </tr>
          </thead>
          <tbody>
            <tr style="border:2px double black;">
              <th scope="row">{{ fatwora.price_before }}</th>
              <td>{{ fatwora.discount }}</td>
              <td>{{ fatwora.price_after }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { fatwora_detail } from "../config/apiRoute.js";
import { appUrl } from "../config/apiConfig.js";
export default {
  data() {
    return {
      loading: true,
      fatwora: {},
      appUrl: ""
    };
  },
  mounted() {
    this.appUrl = appUrl;
    this.get_data();
  },
  methods: {
    print() {
      this.$htmlToPaper("printMe");
    },
    get_data() {
      fatwora_detail(this.$route.params.id).then(response => {
        this.fatwora = response.data;

        this.loading = false;
        setTimeout(() => {
          this.print();
        }, 200);
      });
    }
  }
};
</script>
